/**
 * Admin Dates filter helpers — venue dropdown + persisted selection.
 * @see docs/APP_UI_SPEC.md — C3, F1 (archived venues)
 */

import { venuesVisibleOnPublicHome } from './venuePublicList.js';

export const ADMIN_DATES_VENUE_STORAGE_KEY = 'admin_dates_selected_venue';

/** Venues offered in the Admin Dates filter (excludes archived / inactive). */
export function venuesForAdminDatesFilter(venues) {
  return venuesVisibleOnPublicHome(venues);
}

export function readStoredAdminDatesVenue() {
  try {
    const raw = localStorage.getItem(ADMIN_DATES_VENUE_STORAGE_KEY);
    if (raw === null || raw === '') return 'all';
    if (raw === 'all') return 'all';
    const n = Number(raw);
    return Number.isFinite(n) ? n : 'all';
  } catch {
    return 'all';
  }
}

export function writeStoredAdminDatesVenue(selectedVenue) {
  try {
    localStorage.setItem(ADMIN_DATES_VENUE_STORAGE_KEY, String(selectedVenue));
  } catch {
    /* private mode / quota */
  }
}

/**
 * @param {string|number|'all'} stored
 * @param {Set<number>|Iterable<number>} activeVenueIds
 */
export function resolveAdminDatesVenueSelection(stored, activeVenueIds) {
  if (stored === 'all') return 'all';
  const id = Number(stored);
  if (!Number.isFinite(id)) return 'all';
  const ids = activeVenueIds instanceof Set ? activeVenueIds : new Set(activeVenueIds);
  if (!ids.has(id)) return 'all';
  return id;
}
